export type Theme = 'light' | 'dark' | 'system'

const KEY = 'wami-theme'

export function getStoredTheme(): Theme {
  const raw = localStorage.getItem(KEY)
  return raw === 'light' || raw === 'dark' ? raw : 'system'
}

export function applyTheme(theme: Theme) {
  const root = document.documentElement
  if (theme === 'system') {
    root.removeAttribute('data-theme')
    localStorage.removeItem(KEY)
  } else {
    root.setAttribute('data-theme', theme)
    localStorage.setItem(KEY, theme)
  }
}

export function initTheme() {
  const stored = getStoredTheme()
  if (stored !== 'system') document.documentElement.setAttribute('data-theme', stored)
}
